import { Account } from "./Account";
import { Pro } from "./Pro";
import { Promote } from "./Promote";

export const Modal = {
  Account,
  Pro,
  Promote,
};
